/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IArborb2BContactFormData } from './arborb2b-contact-form.data';
import { IArborb2bContactFormProps } from './arborb2b-contact-form.props.autogenerated';

export type IArborb2bContactFormViewProps = IArborb2bContactFormProps<IArborb2BContactFormData>;

/**
 *
 * Arborb2bContactForm component
 * @extends {React.PureComponent<IArborb2bContactFormProps<IArborb2bContactFormData>>}
 */
class Arborb2bContactForm extends React.PureComponent<IArborb2bContactFormProps<IArborb2BContactFormData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default Arborb2bContactForm;
